import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Space } from 'antd'
import React from 'react'

const DesktopMedicalHistoryNav = ({
  loading,
  saveLoading,
  prevFunction,
  prevText,
  nextFunction,
  nextText,
  prevButtonProps,
  nextButtonProps
}) => {
  return (
    <div className='desktop-form-actions'>
      <Space size='large' style={{ width: '100%', justifyContent: 'center' }}>
        <Button
          className='desktop-cancel-button'
          onClick={() => {
            prevFunction()
          }}
          icon={<FontAwesomeIcon icon={faArrowLeft} />}
          size='large'
          {...prevButtonProps}
        >
          {prevText}
        </Button>

        <Button
          className='desktop-save-button'
          onClick={() => nextFunction()}
          loading={loading || saveLoading}
          icon={<FontAwesomeIcon icon={faArrowRight} />}
          type='primary'
          size='large'
          {...nextButtonProps}
        >
          {nextText}
        </Button>
      </Space>
    </div>
  )
}

export default DesktopMedicalHistoryNav
